import moment from 'moment'
import { IShipmentStopTypes } from 'types/graphqlTypes'
import { IFacilityHourFragment } from 'apps/marketplace/graphql/FacilityHourFragment'
import FORMATS from 'constants/datetime'

const DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']

interface IFindScheduleByDate {
  date: string
  stopType: IShipmentStopTypes
  scheduleHours: IFacilityHourFragment[]
}

/**
 * Returns the schedule for a specific day and stopType
 * @example findScheduleByDate({ date: '2022-02-21', stopType: 'pickup', scheduleHours: []}) // undefined
 */
export const findScheduleByDate = ({
  date,
  scheduleHours,
  stopType,
}: IFindScheduleByDate): IFacilityHourFragment | undefined => {
  const day = moment(date, FORMATS.yearFirst).day()
  const schedule = scheduleHours.filter(({ stopType: hourStopType }) => stopType === hourStopType)
  const scheduleDay = schedule.find(({ day: hourStopDay }) => DAYS[day] === hourStopDay)

  return scheduleDay
}
